module.exports = __webpack_public_path__ + "img/SHBVN.f91a5d4d.svg";